import React from "react";
import { genURL } from './../../_getjson';
import { CSVLink } from "react-csv";
import axios from 'axios'
import '../../_css/Report.css';
import Backdrop from './../../Components/CustomBackdrop/Barckdrop'
import Snackbar from './../../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded'
import Moment from 'moment';


export const ReportsUrl = (reportID) => {
    var Url = "";

    switch (reportID) {
        case "PD001":
            Url += "CSDATA_TO_HONDA/getdata"
            break;
        case "PD002":
            Url += "CSDATA_TO_HONDA_M/getdata"
            break;
        // case "TB002" :
        //     Url += "flow.html?_flowId=viewReportFlow&_flowId=viewReportFlow&ParentFolderUri=%2Freports%2FPSMT_report&reportUnit=%2Freports%2FPSMT_report%2FPurchase_Stiker&standAlone=true";
        //     break;
        // case "TB003" :
        //     Url += "flow.html?_flowId=viewReportFlow&_flowId=viewReportFlow&ParentFolderUri=%2Freports%2FPSMT_report&reportUnit=%2Freports%2FPSMT_report%2FPSMTSTOCKMC_STICKER&standAlone=true";
        //     break;
        default: break;
    }
    // Url += "&j_username=rpt&j_password=042615116&output=pdf&api_key=0WXZeIZXvvbBEoIotvJSC7H3vXnoPfRul9xNdF1u";
    return Url;
}
export default class Reports extends React.Component {
    state = {
        Src: "",
        display: "none",
        display2: "",
        data: "",
        csvData: "",
        autoClose: 3600
    }
    componentDidMount() {
        // console.log("::::::::::::::::::::::::::::::::::xxxxLOAD");
        var Para = ReportsUrl(this.props.reportID);
        Para += "?provenance=web&startDate=" + this.props.Parameter["p_datein"] + "&status=" + this.props.Parameter["p_status"];
        this.setState({ Src: Para });
        // console.log("::::::::::::::::::::::::::::::::::xxxxLOAD:::::::::::::::::::" + Para);
        setTimeout(() => {
            this.createFile()
        }, 100);
    }
    onClose = (e) => {
        this.props.close();
    }
    onShow = () => {
        console.log("onload xxxxx ");
        this.setState({ display: "", display2: "none" });
    }
    createFile = async function () {
        this.setState({ openBackdrop: true })
        await axios.get(genURL(this.state.Src)).then(res => {
            console.log(genURL(this.state.Src));
            if (res.data.length > 0) {
                let rowDataShow = "";
                let docdatenew = "", bdnew = "";
                Moment.locale('en');
                for (let index = 0; index < res.data.length; index++) {

                    if (res.data[index].DOCDATE !== "" && typeof res.data[index].DOCDATE !== "undefined" && res.data[index].DOCDATE !== null) {
                        let date = (Moment(res.data[index].DOCDATE).format('Y-M-D'))
                        docdatenew = date.split("-");
                        docdatenew = (docdatenew[0]) + (docdatenew[1].length === 2 ? docdatenew[1] : "0" + docdatenew[1]) + ((docdatenew[2]).length === 2 ? docdatenew[2] : "0" + docdatenew[2]);
                    }
                    //docdatenew = (docdatenew[0]) + (docdatenew[1].length === 2 ? docdatenew[1] : "0" + docdatenew[1]) + ((docdatenew[2].slice(0, 1)).length === 2 ? docdatenew[0].slice(0, 1) : "0" + docdatenew[0].slice(0, 1));
                    //    bdnew = new Date(res.data[index].BIRTHDAY).toLocaleString().split(" ");
                    if (res.data[index].BIRTHDAY !== "" && typeof res.data[index].BIRTHDAY !== "undefined" && res.data[index].BIRTHDAY !== null) {
                        let bddate = (Moment(res.data[index].BIRTHDAY).format('Y-M-D'))
                        bdnew = bddate.split("-");
                        bdnew = ((bdnew[0]) + (bdnew[1].length === 2 ? bdnew[1] : "0" + bdnew[1]) + (bdnew[2].length === 2 ? bdnew[2] : "0" + bdnew[2]))
                    }
                    rowDataShow += (res.data[index].PERSONTYPE === 0 ? "นิติบุคคล" : "บุคคล")
                        + "|"
                        + "|" + (res.data[index].ARCODE != null ? res.data[index].ARCODE : "")
                        + "|" + (res.data[index].Prefis != null ? res.data[index].Prefis : "")
                        + "|" + (res.data[index].Arname != null ? res.data[index].Arname : "")
                        + "|" + (res.data[index].surname != null ? res.data[index].surname : "")
                        + "|" + (res.data[index].Sex != null ? res.data[index].Sex : "")
                        + "|" + (res.data[index].BIRTHDAY != null ? bdnew : "")
                        + "|" + (res.data[index].HouseNo != null ? res.data[index].HouseNo : "")
                        + "|" + (res.data[index].GroupNo != null ? res.data[index].GroupNo : "")
                        + "|" + (res.data[index].HouseName != null ? res.data[index].HouseName : "")
                        + "|"
                        + "|"
                        + "|"
                        + "|" + (res.data[index].Canton_T != null ? res.data[index].Canton_T : "")
                        + "|" + (res.data[index].Canton_I != null ? res.data[index].Canton_I : "")
                        + "|" + (res.data[index].Canton_P != null ? res.data[index].Canton_P : "")
                        + "|" + (res.data[index].Zip_Code != null ? res.data[index].Zip_Code : "")
                        + "|" + (res.data[index].TELEPHONE != null ? res.data[index].TELEPHONE : "")
                        + "|" + (res.data[index].DealerCode != null ? res.data[index].DealerCode : "")
                        + "|" + (res.data[index].SerialNo != null ? res.data[index].SerialNo : "")
                        + "|" + (res.data[index].DOCDATE != null ? docdatenew : "")
                        + "|Y"
                        + "|Y\n";
                }
                setTimeout(() => {
                    this.setState({ csvData: rowDataShow });
                    this.setState({ rowDataShow: rowDataShow });
                    this.setState({ openBackdrop: false })
                }, 300);
            } else {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "ไม่พบรายการ" })
                this.setState({ icon: ErrorIcon })
                this.setState({ openBackdrop: false })
            }
        })
            .catch(e => {
                // alert  
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: e })
                this.setState({ openBackdrop: false })
            });
    }

    saveFile() {
        // setTimeout(() => {
        //   FileSaver.saveAs(this.state.Src, this.props.Parameter["p_datein"]+"_HONDA.csv");
        // }, 100); 

    }
    render() {
        var mYsty = {
            position: "fixed",
            width: "100%",
            height: "100%",
            left: "0px",
            top: "0px",
            padding: "50px 0px",
            background: "rgba(0,0,0,0.5)",
            "z-index": "100"
        };
        let divData = {
            paddingleft: "50px",
            paddingRight: "50px",
            paddingTop: "30px",
            paddingBottom: "10px",
            background: "rgba(255,255,255,1)",
            scrollBehavior: "auto"
        }
        return (
            <div style={mYsty} className="scroll-wrapper" >
                <Backdrop open={this.state.openBackdrop} />
                <Snackbar place="r"
                    color={this.state.color}
                    icon={this.state.icon}
                    autoClose={this.state.autoClose}
                    message={this.state.messagealert}
                    open={this.state.opensnackbar}
                    closeNotification={() => { this.setState({ opensnackbar: false }) }}
                    close />

                <span style={{ padding: "5px", position: "absolute", right: 20, border: "0px solid red", borderRadius: 100, top: 50, cursor: "pointer", fontSize: 18 }} onClick={this.onClose}><i class="far fa-times-circle"></i></span>
                <span style={{ padding: "5px", position: "absolute", right: 50, border: "0px solid red", borderRadius: 100, top: 50, fontSize: 18 }}>
                    <CSVLink data={this.state.csvData}><i class="fa fa-download" aria-hidden="true"></i>
                    </CSVLink></span>
                <div style={divData}>
                    {this.state.rowDataShow}
                </div>
            </div>
        );
    }
}
